import {
  API_ERROR,
  DEPARTMENTS,
  DEPARTMENT_LIST_SUCCESSFUL,
  DEPARTMENT_ADD,
  DEPARTMENT_ADD_SUCCESSFUL,
  DEPARTMENT_EDIT,
  DEPARTMENT_EDIT_SUCCESSFUL,
  DEPARTMENT_DELETE,
  DEPARTMENT_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
} from "./actionTypes";

const initialState = {
  error: "Sorry! No Data Found.",
  message: null,
  loading: false,
  deparmentslist: [],
  model: false,
  error_msg: null,
  rowdata: {},
};

const department = (state = initialState, action) => {
  switch (action.type) {
    case DEPARTMENTS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DEPARTMENT_LIST_SUCCESSFUL:
      state = {
        ...state,
        deparmentslist: action.payload.response.results,
        loading: false,
      };
      break;
    case DEPARTMENT_ADD:
      state = {
        ...state,
        loading: false,
      };
      break;
    case DEPARTMENT_ADD_SUCCESSFUL:
      state = {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {Id:0},
      };
      break;
    case DEPARTMENT_EDIT:
      state = {
        ...state,
        model: true,
        rowdata: action.payload,
      };
      break;
    case DEPARTMENT_EDIT_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        rowdata: {Id:0},
      };
      break;
    case DEPARTMENT_DELETE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case DEPARTMENT_SETROWDATA:
      state = {
        ...state,
        rowdata: action.payload,
        // model: true,
      };
      break;
    case MODEL_OPEN:
      state = {
        ...state,
        // rowdata: {id:0},
        model: true,
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,
        rowdata: { id: 0 },
        model: false,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default department;
